export default __webpack_public_path__ + "static/media/correct-orient-img.8fc5de53.png";